<template>
  <van-dialog v-model="show" title=" " class="telecom-custom-dialog"  :showConfirmButton="false">
    <div class="custom-header">
      <span  class="cancel-btn" plain  @click="handleCancel" >取消</span>
    </div>
    <div class="content">
      <div class="header-bg">
        <img  src="@/assets/image/telecom-dialog/header-icon.png" alt="">
        <div class="header-text">
          <span class="song-name">{{songName}}</span>
          <span class="actor-name">{{actorName ? actorName: '佚名'}}</span>
        </div>
      </div>
      <div class="header-box">
        <div class="header-title">
          <div class="gradient-border left"></div> <span class="title-text">  畅享VIP特权  </span><div class="gradient-border right"></div>
        </div>

        <ul class="details-info">
          <li class="info-item">
            <img class="icon" src="@/assets/image/telecom-dialog/music.png" alt="">
            <span class="info-name">百万铃声库</span>
          </li>
          <li  class="info-item">
            <img  class="icon" src="@/assets/image/telecom-dialog/change.png" alt="">
            <span class="info-name">彩铃随心换</span>
          </li>
        </ul>
      </div>

        <div class="desc" style="height:30vh;overflow:scroll;font-size:12px !important;margin-top: 0;">
          <span v-html="title" v-if="title" > </span>
        <template v-else>
          视频彩铃专区任选包：资费10元/月；如您未办理视频彩铃功能，点击“立即办理“，将提示办理视频彩铃业务，含视频彩铃功能和视频彩铃专区任选包，资费16元/月。
        </template>
          <span v-if="rules" v-html="rules"></span>
        </div>
    </div>

    <div class="footer-box">
       <van-button color="#EB3B2F" @click="handleConfirm" round style="width: 220px">办理</van-button>
    </div>
  </van-dialog>
</template>

<script>
import { track } from '@/directives/track/send.js'
export default {
  name: 'telecom-confirm-dialog',
  data () {
    return {
      timer: null,
      percentage: 0,
      width: 0,
      show: false,
      resolve: null,
      reject: null,
      rules: '',
      title: '',
      phone: '',
      songName: '',
      actorName: ''
    }
  },
  filters: {
    phoneFilter (value) {
      if (!value) return ''
      if (value.length > 0) {
        return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return value
    }
  },
  methods: {
    handleCancel () {
      this.show = false
      const params = {
        h5_color_ring_general_popup_event_type: '2',
        h5_color_ring_general_popup_type: '6',
        popup_title: '确认办理',
        popup_content: '电信资费规则',
        button_name: '取消按钮'

      }
      track([{ event_id: 'h5_color_ring_general_popup', event_param: params }])
      this.reject()
    },
    handleConfirm () {
      this.show = false
      // debugger
      this.resolve(this.phone)
      const params = {
        h5_color_ring_general_popup_event_type: '2',
        h5_color_ring_general_popup_type: '6',
        popup_title: '确认办理',
        popup_content: '电信资费规则',
        button_name: '办理'

      }
      track([{ event_id: 'h5_color_ring_general_popup', event_param: params }])
    },
    init (resolve, reject, data) {
      const params = {
        h5_color_ring_general_popup_event_type: '1',
        h5_color_ring_general_popup_type: '6',
        popup_title: '确认办理',
        popup_content: '电信资费规则',
        button_name: ''

      }
      track([{ event_id: 'h5_color_ring_general_popup', event_param: params }])
      this.show = true
      this.resolve = resolve
      this.reject = reject
      this.phone = data.phone
      this.rules = data.rules
      this.title = data.title
      this.songName = data.songName
      this.actorName = data.actorName
    },
    close () {
      this.show = false
      const params = {
        h5_color_ring_general_popup_event_type: '2',
        h5_color_ring_general_popup_type: '6',
        popup_title: '确认办理',
        popup_content: '电信资费规则',
        button_name: '取消按钮'

      }
      track([{ event_id: 'h5_color_ring_general_popup', event_param: params }])
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-header{
  color: #EB3B2F;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1.5%;
  padding: 20px 16px 14px 16px;
}
.content {
  padding: 16px;
  padding-top: 0px;
  font-size: 14px;
  .header-bg{
    background-color:#F5F5F5;
    border-radius:12px;
    overflow:hidden;
    display:flex;
    img{
      width:60px;
    }
    .header-text{
      margin-left:16px;
      display:flex;
      flex-direction:column;
      justify-content:center;
      .song-name{
        font-size:14px;
        font-weight:500;
        color:black
      }
      .actor-name{
        font-size:10px;
        line-height:14px;
        color:#939393
      }
    }
  }

  .header-box{
    margin: 20px 0;
    .header-title{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 12px;
      .title-text{
        color: #D9B774;
        font-size: 16px;
        margin: 0 10px;

      }
      .gradient-border {
        position: relative;
        width: 36px;
        height: 1px;
      }

      .gradient-border.right::after {
        content: "";
        position: absolute;
        height: 2px;
        width: 36px;
        background: linear-gradient(to right,  #D9B774, #fffefd, transparent);
      }

      .gradient-border.left::after {
        content: "";
        position: absolute;
        height: 2px;
        width: 36px;
        background: linear-gradient(to left,  #D9B774, #fffefd, transparent);
      }
    }
    .details-info{
      display: flex;
      justify-content:  space-evenly;
      .info-item{
        display: flex;
        flex-direction: column;
        justify-content:center;
        align-items: center;
        .icon{
          width: 40px;
          height: 40px;
          margin-bottom: 12px;
        }

        .info-name{
          font-size: 12px;
          font-weight: 500;
        }
      }

    }
  }
  .desc {
    color: #d1d1d1;
    font-size: 12px;
    line-height: 20px;
  }

}

.footer-box{
    text-align: center;
    padding-bottom: 30px;
    .line{
      position: absolute;
      left: 50%;
      top: 30%;
      background-color: #e0e0e0;
      transform: translateX(-50%);
      width: 1PX;
      height: 20px;
    }
  //  .van-button{
  //     // flex: 1;
  //     height: 58px;
  //     color: #DB382C;
  //     font-size: 16px;
  //     border: unset ;
  //     background: transparent;

  //   }
  }
:deep .van-dialog__header{
  font-weight:500 !important
}

</style>
